import './site.css';
import { initializeDialogs } from './dialogs';
import { initializeToasts } from './toasts';

document.addEventListener('DOMContentLoaded', () => {
  initializeDialogs();
  initializeToasts();
});
